/** AT, @-agents (Frank 24 oktober 2026, opdracht 25 oktober): typ @ in de chat, kies een agent, en
 *  hij draait met het antwoord in het gesprek. PUUR.
 *
 *  Het menu zet alleen `@Naam ` in het invoerveld; de backend (`services/at_agent.py`) herkent de
 *  agent op die tekst. Zo werkt het ook met de hand getypt en in de PWA. */

/** De agents die passen bij wat er na @ staat, of null als het menu dicht hoort. */
export function passendeAgenten(input, agenten) {
  const tekst = input || "";
  if (!tekst.startsWith("@")) return null;
  const rest = tekst.slice(1).toLowerCase();
  const lijst = (agenten || []).filter((a) => a && a.name);
  // Staat er al een volledige naam met een spatie erachter, dan is de keuze gemaakt.
  if (lijst.some((a) => rest.startsWith(`${a.name.toLowerCase()} `))) return null;
  return lijst.filter((a) => a.name.toLowerCase().includes(rest));
}

/** Wat er in het invoerveld komt na het kiezen van een agent. */
export function metAgent(agent) {
  return `@${agent.name} `;
}
